// Reusable person card: shows a team member photo, name, and role.

import "../../styles/Home.css";

function PersonCard({
  name,
  role,
  imageSrc,
  imageAlt,
  linkedIn,
  style,
  className = "",
}) {
  const alt = imageAlt || name;

  const content = (
    <>
      <img
        className="personCard__avatarImg"
        src={imageSrc}
        alt={alt}
        loading="lazy"
      />

      <div className="personCard__meta">
        <div className="personCard__name">{name}</div>
        <div className="personCard__role">{role}</div>
      </div>
    </>
  );

  // If LinkedIn exists, make entire card clickable
  if (linkedIn) {
    return (
      <a
        href={linkedIn}
        target="_blank"
        rel="noreferrer"
        className={`personCard personCard--link ${className}`.trim()}
        style={style}
        aria-label={`${name} LinkedIn Profile`}
      >
        {content}
      </a>
    );
  }

  return (
    <article
      className={`personCard ${className}`.trim()}
      style={style}
    >
      {content}
    </article>
  );
}

export default PersonCard;